import { mockApiBoundaryInterceptor } from './mock-api.interceptor';

import type { HttpInterceptorFn } from '@angular/common/http';

/**
 * Camada de mock para desenvolvimento e builds não produtivos (ex.: `ng serve --configuration mock`).
 * A substituição em `mock-api.providers.prod.ts` evita levar o interceptor e os handlers no bundle de produção.
 */
export function provideMockApiLayer(): { interceptors: HttpInterceptorFn[] } {
  return { interceptors: [mockApiBoundaryInterceptor] };
}
